export const subscriptionGroupsKey = "/engagement/:app_group_id/email_subscription_groups" as const;
